import { atom } from "jotai";

type AtomValue = {
  isOpen: boolean;
};

export const refineSearchDrawerAtom = atom<AtomValue>({ isOpen: false });
